<template>
    <router-link :to="{ name: route, params: params, query: query }"
                 v-if="checkIfVisible()"
                 tag="a">
        {{ $t(title) }}
    </router-link>
</template>

<script>
import { checkUserPermissions } from '@/config/AppConfig'

export default {
  props: ['route', 'query', 'permissionParam', 'title', 'params'],
  methods: {
    checkIfVisible () {
      if (this.permissionParam !== undefined && this.permissionParam !== null) {
        return checkUserPermissions(this.permissionParam)
      }
      return true
    }
  }
}
</script>
